export interface Testimonial {
  name: string;
  tag: string;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    name: "追更的阿岚",
    tag: "从开篇追到现在",
    text: "最省心的就是追更话数整理，剧情阶段分得很清楚，每次想回顾某段主线都能秒定位，不用自己在平台里翻半天。",
  },
  {
    name: "书页之间",
    tag: "漫画党",
    text: "最新剧情速览更新得很及时，剧情主线的时间线也讲得明白，对刚入坑想补进度的朋友特别友好。",
  },
  {
    name: "蓝银草爱好者",
    tag: "设定考据党",
    text: "双武魂、魂环体系这类设定解析写得很扎实，看得出是真读过原文的人整理的，不是泛泛而谈。",
  },
];